import { render, staticRenderFns } from "./NewShoppingChart.vue?vue&type=template&id=e2d3ce42&scoped=true"
import script from "./NewShoppingChart.vue?vue&type=script&lang=js"
export * from "./NewShoppingChart.vue?vue&type=script&lang=js"
import style0 from "./NewShoppingChart.vue?vue&type=style&index=0&id=e2d3ce42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d3ce42",
  null
  
)

export default component.exports